export default __webpack_public_path__ + "static/media/waave_health_green_white.2afa5b3e.png";